__turbopack_context__.v({
  "chevron": "footerBottom-module-scss-module__DInP-a__chevron",
  "copyrightBankLogos": "footerBottom-module-scss-module__DInP-a__copyrightBankLogos",
  "developerOrigin": "footerBottom-module-scss-module__DInP-a__developerOrigin",
  "footerBottom": "footerBottom-module-scss-module__DInP-a__footerBottom",
  "footerMenu": "footerBottom-module-scss-module__DInP-a__footerMenu",
  "footerMenuWrapper": "footerBottom-module-scss-module__DInP-a__footerMenuWrapper",
  "hovered": "footerBottom-module-scss-module__DInP-a__hovered",
  "menuItem": "footerBottom-module-scss-module__DInP-a__menuItem",
  "menuLink": "footerBottom-module-scss-module__DInP-a__menuLink",
  "rotated": "footerBottom-module-scss-module__DInP-a__rotated",
  "submenu": "footerBottom-module-scss-module__DInP-a__submenu",
  "submenuLink": "footerBottom-module-scss-module__DInP-a__submenuLink",
  "visible": "footerBottom-module-scss-module__DInP-a__visible",
  "wrapper": "footerBottom-module-scss-module__DInP-a__wrapper",
});
